import { gql } from "@apollo/client";

import { organizationsFragment } from "../fragments";

import { type GetOrganizationsQuery } from "./getOrganizations.gql-generated";

export type OrganizationsList = GetOrganizationsQuery["getMyLensesOrganizations"]["organizationsList"];

export const getOrganizations = gql`
    query getOrganizations {
        getMyLensesOrganizations {
            ...Organizations
        }
    }
    ${organizationsFragment}
`;
